export const anchorScroll = (element: HTMLElement) => {
  const stickyHeaderHeight = getStickyHeaderHeight();
  const stickyAd = document.querySelector('[id="WIX_ADS"]')?.clientHeight || 0;
  const mobileToolbar =
    document.querySelector('[data-hook="mobile-toolbar"]')?.clientHeight ||
    document.querySelector('[data-hook="ricos-editor-toolbars"]')?.clientHeight ||
    0;
  const fixedElementsOffset = stickyHeaderHeight + stickyAd + mobileToolbar;
  anchorScrollUsingScrollIntoView(element, fixedElementsOffset);
};

const anchorScrollUsingScrollIntoView = (element: HTMLElement, fixedElementsOffset: number) => {
  const { paddingTop, marginTop } = element.style;
  element.style.marginTop = `-${fixedElementsOffset}px`;
  element.style.paddingTop = `${fixedElementsOffset}px`;
  element.scrollIntoView({ behavior: 'smooth' });
  element.style.marginTop = marginTop;
  element.style.paddingTop = paddingTop;
};

const getStickyHeaderHeight = () => {
  // This accounts for classical sites header section if it has fixed position
  const header = document.querySelector('[id="SITE_HEADER"]');
  if (!header) {
    return 0;
  }

  const position = getComputedStyle(header).getPropertyValue('position');
  if (position === 'fixed' || position === 'sticky') {
    return header.clientHeight;
  }

  return 0;
};

export const addAnchorTagToUrl = (anchorString: string) => {
  const url = new URL(window.location.href);
  url.hash = anchorString;
  history.pushState({}, '', url.href);
};
